import { useEffect } from 'react';
import { BrowserRouter, Routes, Route} from 'react-router-dom';
import './App.css';
import Menu from './components/layout/Menu';
import Footer from './components/layout/Footer';

import Home from './pages/Home';
import Nosotros from './pages/Nosotros';
import Portafolio from './pages/Portafolio';
import Contacto from './pages/Contacto';
import SeoPage from './pages/SeoPage';
import Perfil from './pages/Perfil';
import CambiarContrasena from './pages/CambiarContrasena';
import Soporte from './pages/Soporte';

function App() {

    useEffect(() => {
    });

  return (
    <div className="App">
      <BrowserRouter>
      <Menu></Menu>
      <Routes>        
          <Route path="/nosotros" element={<Nosotros />} /> 
          <Route path="/inicio" element={<Home />} />
          <Route path="/portafolio" element={<Portafolio />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/perfil" element={<Perfil />} />
          <Route path="/cambiar-contrasena" element={<CambiarContrasena />} />
          <Route path="/soporte" element={<Soporte />} />
          <Route path="/pagina/:slug" element={<SeoPage />} />
          <Route path="/" element={<Home />}/>    
          <Route path="*" element={<Home />}/>
      </Routes>
      <Footer></Footer>
      </BrowserRouter>
      
    </div>
  );
}

export default App;
